import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
        ✨دامنه های زیر بفروش میرسد، جهت رزرو با 09122305108 در ارتباط باشید✨
        
        </p>
        <p>  🌐 webani.ir 🌐 digidj.ir 🌐 betoremesal.ir 🌐 sarabmobile.ir 🌐 divarsarab.ir 🌐 foroshdoreh.ir 🌐</p>

        
        <a
          className="App-link"
          href="https://webmaster7.ir"
          target="_blank"
          rel="noopener noreferrer"
        >
           
           
           ©️Copyright 2025 , All Rights Reserved - made with ❤️ webmaster7.ir
        </a>
      </header>
    </div>
  );
}

export default App;
